import React from "react";
import * as CoreComponents from "@nuwatop/code-canvas-core";

// 组件注册表
const componentRegistry = new Map<string, React.ComponentType<any>>();

/**
 * 初始化默认组件注册
 */
const initDefaultComponents = () => {
  // 注册所有 And* 组件
  const coreExports = CoreComponents as Record<string, any>;

  Object.keys(coreExports).forEach((key) => {
    if (key.startsWith("And") && typeof coreExports[key] === "function") {
      const componentName = key.toLowerCase().replace("and", "and-");
      componentRegistry.set(componentName, coreExports[key]);
      // 也注册不带前缀的版本
      componentRegistry.set(key, coreExports[key]);
    }
  });
};

// 初始化
initDefaultComponents();

/**
 * 注册自定义组件
 */
export const registerComponent = (
  name: string,
  component: React.ComponentType<any>
) => {
  componentRegistry.set(name, component);
  componentRegistry.set(name.toLowerCase(), component);
};

/**
 * 获取组件
 */
export const getComponent = (
  name: string
): React.ComponentType<any> | undefined => {
  // 先尝试原名
  let component = componentRegistry.get(name);
  if (component) return component;

  // 尝试小写
  component = componentRegistry.get(name.toLowerCase());
  if (component) return component;

  // 尝试 And 前缀
  if (!name.startsWith("And")) {
    component = componentRegistry.get(`And${name}`);
    if (component) return component;
  }

  // 尝试 and- 前缀
  if (!name.startsWith("and-")) {
    component = componentRegistry.get(`and-${name.toLowerCase()}`);
  }

  return component;
};

/**
 * 获取所有已注册组件
 */
export const getRegisteredComponents = (): string[] => {
  return Array.from(componentRegistry.keys());
};

/**
 * ComponentRegistry 对象
 */
export const ComponentRegistry = {
  register: registerComponent,
  get: getComponent,
  getAll: getRegisteredComponents,
  has: (name: string) =>
    componentRegistry.has(name) || componentRegistry.has(name.toLowerCase()),
};

export default ComponentRegistry;
